import { render, staticRenderFns } from "./clientmanage.vue?vue&type=template&id=5ab88b0c"
import script from "./clientmanage.vue?vue&type=script&lang=js"
export * from "./clientmanage.vue?vue&type=script&lang=js"
import style0 from "./clientmanage.vue?vue&type=style&index=0&id=5ab88b0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports